import { animate, style, transition, trigger } from '@angular/animations';

export class AnimationsService {

  constructor() {
  }

  public static ENTER_EASE_OUT_FROM_RIGHT(triggerName: string): any {
    return trigger(triggerName, [
      transition(':enter', [
        style({transform: 'translateX(200px)'}),
        animate('200ms ease-out', style({transform: 'none'}))
      ])
    ]);
  }
}
